import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../models/appconfig';
import { map } from 'rxjs/operators';

@Injectable()

export class AppConfigService {
    _appConfig: AppConfig;

    constructor(private _http: HttpClient) { }

    /**
     * Returns a Promise AppConfig from the server or from the data store if cached
     */
  getAppConfig(): Promise<AppConfig> {
        if (this._appConfig != null) {
            return new Promise((resolve) => {
                resolve(this._appConfig);
            });
        }
        else {
            return new Promise((resolve) => {
                this._http.get('api/data/app-config').pipe(
                    map(response => new AppConfig(response))
                    ).subscribe(data => {
                        this._appConfig = data; // cache the config
                        resolve(data);
                    }, error => {
                        this.handleError("An error occurred retrieving the app config.", error);
                        //reject();
                    });
            })
        }
    }

    private handleError(message?: string, errorResponse?: any) {
        console.error(Error(message || "" + errorResponse.statusText || ""));
    }

}
